import { IconComponent } from './types';

const PipesIcon: IconComponent = (props) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 9.66667H12V8.33333H0V9.66667ZM0 11.6667H12V11H0V11.6667ZM0 7H12V5H0V7ZM0 1V3.66667H12V1H0Z"
      fill="currentColor"
    />
  </svg>
);

export default PipesIcon;
